import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showFooter:0,
    currentPage:'/login'
  },
  mutations: {
    changefooter(state,x){
      state.showFooter = x[0]
      state.currentPage = x[1]
    },
  },
  actions: {
  },
  modules: {
  }
})
